export default __webpack_public_path__ + "static/media/monkey_white_female.a551b308.png";